import { queryOptions, type QueryClient, type QueryKey } from '@tanstack/react-query';
import { consoleApi } from '../api/client';
import type { ManagementJob } from '../types';

export function isJobComplete(job: ManagementJob | undefined) {
  return job?.status === 'SUCCEEDED' || job?.status === 'FAILED';
}

/** Poll accepted work only; terminal results refresh the views that work can change. */
export function jobProgressOptions(jobId: string | undefined, client: QueryClient, resultKeys: QueryKey[]) {
  const id = Number(jobId);
  const enabled = Number.isSafeInteger(id) && id > 0;
  return queryOptions({
    queryKey: ['job', id],
    enabled,
    queryFn: async () => {
      if (!enabled) throw new Error('No accepted job is available to check.');
      const job = await consoleApi.job(id);
      if (isJobComplete(job)) {
        await Promise.all(resultKeys.map(queryKey => client.invalidateQueries({ queryKey })));
      }
      return job;
    },
    refetchInterval: query => isJobComplete(query.state.data) || query.state.status === 'error' ? false : 2_000
  });
}
